module.exports = __webpack_public_path__ + "img/e4.9fd97919.jpg";